/** Client mirror of `server/audit/timelineTypes.ts` (OAT-1 / OAT-4). */

export type TimelineSource =
  | "audit_log"
  | "lead_event"
  | "ops_deal_timeline"
  | "ops_order_intake"
  | "profile_access"
  | "ops_integration"
  | "opp_event";

export type TimelineDomain = "sales" | "ops" | "mfg" | "auth" | "integration";

export type TimelineTestDataFilter = "exclude" | "include" | "test_only";

export type TimelineEntry = {
  id: string;
  source: TimelineSource;
  organization_id: string;
  occurred_at: string;
  actor_user_id: string | null;
  actor_label: string;
  domain: TimelineDomain;
  entity_type: string;
  entity_id: string;
  action: string;
  summary: string;
  metadata: Record<string, unknown>;
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  deep_link: string | null;
};

export type ActivityTimelineScope = "org" | "platform";

export type ActivityTimelineQuery = {
  scope: ActivityTimelineScope;
  organization_id?: string;
  since?: string;
  until?: string;
  actor_user_id?: string;
  actor_label_contains?: string;
  domain?: TimelineDomain;
  entity_type?: string;
  entity_id?: string;
  action?: string;
  q?: string;
  source?: TimelineSource;
  test_data?: TimelineTestDataFilter;
  limit?: number;
  offset?: number;
};

export type ActivityTimelineResponse = {
  ok: true;
  entries: TimelineEntry[];
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
  sources_queried: TimelineSource[];
  federation_truncated?: boolean;
  sources_unavailable?: TimelineSource[];
};

export const TIMELINE_DEFAULT_LIMIT = 50;
export const TIMELINE_MAX_LIMIT = 200;

export const TIMELINE_DOMAIN_OPTIONS: { value: "" | TimelineDomain; label: string }[] = [
  { value: "", label: "All domains" },
  { value: "sales", label: "sales" },
  { value: "ops", label: "ops" },
  { value: "mfg", label: "mfg" },
  { value: "auth", label: "auth" },
  { value: "integration", label: "integration" },
];

export const TIMELINE_SOURCE_OPTIONS: { value: "" | TimelineSource; label: string }[] = [
  { value: "", label: "All sources" },
  { value: "audit_log", label: "audit_log" },
  { value: "lead_event", label: "lead_event" },
  { value: "ops_deal_timeline", label: "ops_deal_timeline" },
  { value: "ops_order_intake", label: "ops_order_intake" },
  { value: "ops_integration", label: "ops_integration" },
];

export const TIMELINE_TEST_DATA_OPTIONS: { value: TimelineTestDataFilter; label: string }[] = [
  { value: "exclude", label: "Production only" },
  { value: "include", label: "Include all" },
  { value: "test_only", label: "Test only" },
];
